<div class="view-content-mode">
  <!-- Description -->
  <app-view-panel [showHeader]="false" *ngIf="isVisible(viewLayout.Description)" [hidden]="!isPopulated">
    <app-view-description [(isPopulated)]="isPopulated" [layout]="layout"></app-view-description>
  </app-view-panel>

  <!-- Labels -->
  <app-view-panel label="Labels" *ngIf="(labels$ | async)?.length && isVisible(viewLayout.LabelList)">

    <!-- Label actions -->
    <div actions *ngIf="(labels$ | async)?.length > 1" class="flex">
      <app-pin-button 
        icon="chevron-left"
        size="small"
        type="ghost" 
        matTooltip="Previous Label"
        (click)="handlePrevClick()">
      </app-pin-button>

      <app-pin-button
        icon="chevron-right"
        size="small"
        type="ghost" 
        matTooltip="Next Label"
        (click)="handleNextClick()">
      </app-pin-button>

    </div>

    <app-view-labels></app-view-labels>
  </app-view-panel>

  <!-- Chapters -->
  <app-view-panel label="Chapters" *ngIf="(chapters$ | async)?.length > 1 && isVisible(viewLayout.ChapterList)">
    <app-view-chapters [showHeader]="false" [showList]="true"></app-view-chapters>
  </app-view-panel>
</div>